import styled from "styled-components";
import { SIZE, gutter, mediaQuery, unit } from "../../../theme/metrics";
import { typeBodyMd, typeHeadingLg, typeLabelMd } from "../../../theme/typography";

export const StyledContainer = styled.div`
	row-gap: ${unit(2)};
	display: flex;
	flex-direction: column;

	${mediaQuery[SIZE.large]} {
		display: grid;
		grid-auto-flow: dense;
		grid-template-rows: auto;
		grid-template-columns: repeat(12, [col-start] 1fr);
    column-gap: ${gutter(SIZE.large)};
  }

  ${mediaQuery[SIZE.xlarge]} {
    column-gap: ${gutter(SIZE.xlarge)};
  }

  ${mediaQuery[SIZE.max]} {
    column-gap: ${gutter(SIZE.max)};
  }
`

export const StyledContent = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: ${unit(2)};

	${mediaQuery[SIZE.large]} {
		grid-column: 1 / span 8;
		row-gap: ${unit(4)};
	}
`

export const StyledLinks = styled.div`
	${mediaQuery[SIZE.large]} {
		display: flex;
		grid-column: 9 / span 4;
		justify-content: flex-end;
		align-items: flex-end;
	}
`

export const StyledLabel = styled.div`
	${typeLabelMd};
	width: 100%;
	color: ${props => props.theme.alternative};
`;

export const StyledHeading = styled.h2`
	${typeHeadingLg};
	color: ${props => props.theme.primary};
`;

export const StyledDescription = styled.div`
  ${typeBodyMd}
	color: ${props => props.theme.alternative};

	p{
		margin-bottom: ${unit(2)};

		&:last-child{
			margin-bottom: 0;
		}
	}

	a {
		color: ${props => props.theme.alternative};
	}
`;